import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const Error = () => {
  // Framer motion animation settings for heading
  const headingVariants = {
    hidden: { opacity: 0, x: 50 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: {
        delay: i * 0.1,
        type: "spring",
        stiffness: 120,
      },
    }),
  };

  const headingText = "404";

  return (
    <>
      <Helmet>
        {/* Basic Meta Tags */}
        <title> 404 | MSB Association Membership</title>
        <meta name="description" content="" />

        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="404 | MSB Association Membership " />
        <meta property="og:description" content="" />

        <meta
          property="og:image"
          content="https://msbassociationuk.org/assets/images/logo.svg"
        />

        <meta property="og:type" content="website" />

        {/* Twitter Meta Tags */}
      </Helmet>
      <main className="page_content">
        {/* Page Header - Start
    ================================================== */}
        <section
          id="overview"
          className="page_header text-center  section_decoration overflow-hidden pb-0"
        >
          <div className="container">
            <ul className="breadcrumb_nav unordered_list justify-content-center"></ul>
          </div>
        </section>
        {/* Page Header - End
    ================================================== */}
        {/* Webinar Form Section - Start
    ================================================== */}
        <section className="job_apply_section pt-3 pb-5">
          <div style={{ maxWidth: "850px", margin: "0 auto" }}>
            <div className="mt-5">
              <div className="heading_block mb-2">
                <h1
                  className="heading_text text-center"
                  style={{
                    fontSize: "300px",
                  }}
                >
                  {headingText.split("").map((char, i) => (
                    <motion.span
                      key={`${char}-${i}`}
                      custom={i}
                      initial="hidden"
                      animate="visible"
                      variants={headingVariants}
                    >
                      {char}
                    </motion.span>
                  ))}
                </h1>

                <div className="row justify-content-center align-items-center mt-3 mb-2">
                  <div className="col-lg-12">
                    <div className="blog_post_block mt-5 text-center">
                      <h3 className="text-center">Opps! Page not found</h3>
                      <p className="text-center">
                        We're sorry, the page you have looked for does not exist
                        in our database! Maybe go to our home page or try to use
                        a search?
                      </p>
                      <NavLink
                        className="btn bg-primary text-dark"
                        to="/"
                      >
                        <span className="btn_label">Back to Home</span>
                      </NavLink>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default Error;
